import {Reducer} from 'redux'
import {CustomersActionTypes, CustomersState} from './types';
import CustomersService from '../../services/CustomersService';
import ContactsService from '../../services/ContactsService';

// Type-safe initialState!
const initialState: CustomersState = {
	list: [],
	selected: null,
	finances: []
}

// Thanks to Redux 4's much simpler typings, we can take away a lot of typings on the reducer side,
// everything will remain type-safe.
const reducer: Reducer<CustomersState> = (state = initialState, action) => {
	switch (action.type) {
		case CustomersActionTypes.FETCH_ALL_REQUEST: {
			CustomersService.getAll()
			return { ...state, loading: true }
		}
		case CustomersActionTypes.FETCH_ALL_COMPLETED: {
			return { ...state, loading: false, list: action.payload}
		}
		case CustomersActionTypes.FETCH_ONE_REQUEST: {
			CustomersService.getOne(action.payload)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.FETCH_ONE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case CustomersActionTypes.SAVE_REQUEST: {
			CustomersService.save(action.payload)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.SAVE_COMPLETED: {
			let newCustomer = action.payload
			let foundIndex = state.list.findIndex(element => element.id === newCustomer.id)
			state.list.splice(foundIndex, 1, action.payload)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case CustomersActionTypes.DELETE_REQUEST: {
			CustomersService.delete(action.payload)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.DELETE_COMPLETED: {
			let foundIndex = state.list.findIndex(element => element.id === action.payload.id)
			state.list.splice(foundIndex, 1)
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case CustomersActionTypes.DELETE_MULTIPLE_REQUEST: {
			CustomersService.deleteCustomers(action.payload)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.DELETE_MULTIPLE_COMPLETED: {
			action.payload.forEach((item: any) => {
				let foundIndex = state.list.findIndex(element => element.id === item.id)
				state.list.splice(foundIndex, 1)
			});
			let newList = [...state.list]
			return { ...state, loading: false, list: newList}
		}
		case CustomersActionTypes.SAVE_CONTACT_REQUEST: {
			ContactsService.save(action.payload.contact, action.payload.index)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.SAVE_CONTACT_COMPLETED: {
			let newContact = action.payload.contact
			let foundIndexCustomer = state.list.findIndex(element => element.id === newContact.customerId)
			let customer = state.list[foundIndexCustomer]
			let foundIndex = customer.contacts.findIndex(element => element.title === newContact.title &&
				element.email === newContact.email &&
				element.phone === newContact.phone)
			customer.contacts.splice(foundIndex, 1, newContact)
			state.list.splice(foundIndexCustomer, 1, customer)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case CustomersActionTypes.DELETE_CONTACT_REQUEST: {
			ContactsService.delete(action.payload)
			return { ...state, loading: true }
		}
		case CustomersActionTypes.DELETE_CONTACT_COMPLETED: {
			let newContact = action.payload
			let foundIndexCustomer = state.list.findIndex(element => element.id === newContact.customerId)
			let customer = state.list[foundIndexCustomer]
			let foundIndex = customer.contacts.findIndex(element => element.title === newContact.title &&
				element.email === newContact.email &&
				element.phone === newContact.phone)
			customer.contacts.splice(foundIndex, 1)
			state.list.splice(foundIndexCustomer, 1, customer)
			let newList = [...state.list]
			return { ...state, list: newList}
		}
		case CustomersActionTypes.FETCH_FINANCES: {
			return { ...state, finances: action.payload }
		}
		case CustomersActionTypes.DELETE_FINANCES: {
			return { ...state, finances: action.payload }
		}
		default: {
			return state
		}
	}
}

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
export { reducer as CustomersReducer }
